<div class="dialog-content">
  <h2>{{ data.mode === 'view' ? 'Information SDA' : 'Modifier SDA' }}</h2>

  <form [formGroup]="form" class="form-fields">

    <!-- SDA -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>SDA</mat-label>
      <input matInput formControlName="number" />
    </mat-form-field>

    <!-- Destination -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Destination</mat-label>
      <input type="text" matInput [matAutocomplete]="autoExt" formControlName="target"
        [readonly]="data.mode === 'view'" />
      <mat-autocomplete #autoExt="matAutocomplete">
        @for (ext of filteredExtensions; track ext.id) {
        <mat-option [value]="ext.id">
          {{ ext.number }} ({{ ext.name }})
        </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <!-- Nature de la destination -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Nature de la destination</mat-label>
      <mat-select formControlName="targetType">
        @for (t of targetTypes; track t.value) {
        <mat-option [value]="t.value">{{ t.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

  </form>

  <!-- Historique -->
  @if (data.mode === 'view') {
  <app-historique [uidObject]="data.sda.id" [uidEntreprise]="data.sda.organizationId">
  </app-historique>
  }

  <!-- Actions -->
  <div class="actions">
    <button mat-stroked-button class="accent-button" mat-dialog-close>Fermer</button>
    @if (data.mode !== 'view') {
    <button mat-raised-button class="accent-button" (click)="onSave()" [disabled]="form.invalid">
      Enregistrer
    </button>
    }
  </div>
</div>

<ngx-spinner name="spinner" bdColor="rgba(0, 0, 0, 0.2)" size="medium" color="#00D2B4" type="timer"
  [fullScreen]="false"></ngx-spinner>